export default __webpack_public_path__ + "slices/main/assets/public/media/masthead/haw-ebook-thumb@2x.44de3607e1a5af95eec6973789c202c7.png";